










import { defineComponent, ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import usePager from "@/hooks/usePager";
import providers from "@/lib/api";
import BasePage from "@/components/BasePage";
import EmptyContent from "@/components/EmptyContent";
import InfiniteScroll from "@/components/InfiniteScroll";
import PageTitle from "@/components/PageTitle";
import CreatorsByTalentRepList from "./components/CreatorsByTalentRepList.vue";

export default defineComponent({
  name: "PageCreatorsByTalentRep",
  components: { BasePage, PageTitle, CreatorsByTalentRepList, InfiniteScroll, EmptyContent },
  setup() {
    const { authUserStrict } = useAuthUser();
    const loading = ref<boolean>(false);

    const { enableScroll, items, getNextPage, getFirstPage } = usePager(page =>
      providers.TalentAgentsProvider.search({
        data: {
          agentId: authUserStrict.value.id,
          page,
          size: 20,
          sort: "TIME,DESC",
        },
      })
    );

    const getData = () => {
      loading.value = true;
      getFirstPage().finally(() => (loading.value = false));
    };

    getData();

    return { loading, items, enableScroll, getNextPage };
  },
});
